/**
 * Player Auth Metrics
 *
 * Side-effect module imported by app.tsx to observe the global auth store
 * and fire a User Authenticated analytic whenever a new playerAuthId appears.
 *
 * This listener covers non-quickstart auth paths (pavilion join flow, etc.)
 * The QuickstartTelemetryManager.sendAuthSucceeded covers the quickstart-specific
 * path with richer context (authProvider, accountState, quickstartSlug, etc.).
 *
 * TODO: Consolidate with sendAuthSucceeded once the OAuth return path in
 * QuickstartCoordinator.onInit is updated to always call onAuthSuccess,
 * ensuring the richer event always fires. At that point this listener can
 * be removed and this file deleted.
 */

import { sendAnalytics } from './telemetry/client';
import { getPersistentPlayerId } from './api';
import { authStore } from './api/stores/globalStores';

const persistentId = getPersistentPlayerId();

authStore.addListener((state, previousState) => {
  if (state.playerAuthId && state.playerAuthId !== previousState?.playerAuthId) {
    sendAnalytics({
      name: 'User Authenticated',
      role: 'player',
      playerAuthId: state.playerAuthId,
      persistentId,
      source: 'browser',
    });
  }
});
